<template>
  <v-banner
    style="padding: 0 !important"
    class="general-banner"
    :class="{ 'mobile-banner-container': mobileBanner }"
  >
    <v-img
      :src="require('@/assets/shared/redesign/backgrounds/banner-pattern.svg')"
      contain
      class="banner-pattern"
    >
      <div class="co-branded-image-container">
        <img
          :src="coBrandedImageUrl"
          alt="Co branded image url"
          style="max-width: 207px"
        />
      </div>
    </v-img>
  </v-banner>
</template>

<script>
  export default {
    name: 'CoBrandedBanner',
    data() {
      return {
        mobileBanner: false,
      };
    },
    props: {
      bannerText: {
        required: true,
        default: '',
        type: String,
      },
    },
    computed: {
      isMobile() {
        return this.$isMobileDevice() || window.innerWidth <= 900;
      },
      coBrandedImageUrl() {
        return require('@/assets/' + this.whitelabel.coBranded.coBrandedBanner);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .general-banner {
    background-color: #1e1e1e !important;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;

    .co-branded-image-container {
      align-self: center;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .banner-text {
      color: white;
      height: 100%;
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
      text-align: center;
      padding: 0 16px;
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
      .mobile-banner {
        display: block;
        word-break: break-word;
        overflow-wrap: break-word;
        max-width: 95dvw;
      }
    }

    .banner-pattern {
      height: 100%;
    }
  }
  .mobile-banner-container {
    height: auto !important;
  }
</style>
